export default function formatDate(dateString) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const [year, month, day] = dateString.split("-");

    return `${day} ${months[parseInt(month) - 1]}, ${year}`;
}